export enum NavigationMenuEnum {
  Main = 'main',
  Facilities = 'facilities',
  Placement = 'placement',
  Workers = 'workers',
  Devices = 'devices',
  Firmwares = 'firmwares',
  Maintenance = 'maintenance',
  Agents = 'agents',
  Scanner = 'scanner',
  Notifications = 'notifications',
  Energy = 'energy',
  History = 'history',
  ServiceCenters = 'service-centers',
  KnowledgeBase = 'knowledge',
  Users = 'users',
  Roles = 'roles',
}
